import { Collection } from 'modules/core/lib/mobx-rest'

import UnassignedShift from 'modules/shift_management/store/api/models/UnassignedShift'

class UnassignedShifts extends Collection<UnassignedShift> {
  get cacheKey(): string {
    return 'unassignedShifts'
  }
  model() {
    return UnassignedShift
  }
}

const singleton: UnassignedShifts = new UnassignedShifts()

export default singleton
